import { LinkmailType } from "shared/models/breakdown";

import { IPaginatedData } from "models/common";

export enum JobItemType {
  Linkmail,
  Role,
  FollowUp,
}

export interface IJobItem {
  sender: string;
  senderId: string;
  title: string;
  roleTitle: string;
  roleId?: string;
  followUpId?: string;
  productionTypeId: number;
  contractTypeId: number;
  amendmentCount?: number;
  sentDate: string;
  closingDate?: string;
  type: JobItemType;
  linkmailType?: LinkmailType;
  linkmailId: string;
  isRead: boolean;
  isSuggested: boolean;
  isNudged: boolean;
  freezeDate?: string;
  isLocalHire?: boolean;
  productionLocation?: string;
  productionLocationId?: string;
  earlyApplyLimit?: number;
  isCast: boolean;
  closedEarly?: boolean;
  closedReason?: string;
}

export interface IPaginatedJobItemList extends IPaginatedData<IJobItem> {}

export interface IReportConcernData {
  linkmailId: string;
  roleId: string;
  type: string;
  details: string;
}

export enum InteractionActionType {
  Add,
  Remove,
}
